import 'css-chunksrc/client/common/projectSection/styles.scss';export default {
  "main": "_main_11mfc_1",
  "row": "_row_11mfc_11",
  "avatar": "_avatar_11mfc_20",
  "header": "_header_11mfc_28",
  "weather": "_weather_11mfc_40",
  "strategicScore": "_strategicScore_11mfc_41",
  "activityMonitoring": "_activityMonitoring_11mfc_48",
  "workload": "_workload_11mfc_49",
  "budget": "_budget_11mfc_50",
  "text": "_text_11mfc_65",
  "labels": "_labels_11mfc_70",
  "label": "_label_11mfc_70",
  "sortable": "_sortable_11mfc_98",
  "labelGroup": "_labelGroup_11mfc_106",
  "projects": "_projects_11mfc_125",
  "project": "_project_11mfc_125",
  "opened": "_opened_11mfc_136",
  "toggleArrow": "_toggleArrow_11mfc_136",
  "menuIcon": "_menuIcon_11mfc_140",
  "removeIcon": "_removeIcon_11mfc_144",
  "positive": "_positive_11mfc_148",
  "warning": "_warning_11mfc_152",
  "titles": "_titles_11mfc_156",
  "budget_allocatedBudget": "_budget_allocatedBudget_11mfc_180",
  "budget_plannedBudget": "_budget_plannedBudget_11mfc_180",
  "budget_realCosts": "_budget_realCosts_11mfc_180",
  "budget_plannedMargin": "_budget_plannedMargin_11mfc_180",
  "budget_realMargin": "_budget_realMargin_11mfc_180",
  "budget_acquiredValue": "_budget_acquiredValue_11mfc_180",
  "workload_allocatedTime": "_workload_allocatedTime_11mfc_180",
  "workload_spentTime": "_workload_spentTime_11mfc_180",
  "workload_remainingWork": "_workload_remainingWork_11mfc_180",
  "activityMonitoring_done": "_activityMonitoring_done_11mfc_180",
  "activityMonitoring_delayed": "_activityMonitoring_delayed_11mfc_180",
  "activityMonitoring_opened": "_activityMonitoring_opened_11mfc_180",
  "col": "_col_11mfc_192",
  "icon": "_icon_11mfc_205"
};